import React from "react";

const PatientHistoryModal = ({ show, data, loading, onClose, patientName, uhid }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content history-modal">
        {/* Header */}
        <div className="modal-header">
          <div>
            <h5>Patient History Timeline</h5>
            <p className="subtitle">{patientName} ({uhid})</p>
          </div>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        {/* Body */}
        <div className="modal-body">
          {loading ? (
            <div className="text-center py-4"><span className="spinner-border text-primary"></span> Loading...</div>
          ) : data.length === 0 ? (
            <div className="empty-state">No medical history found for this patient.</div>
          ) : (
            <div className="table-responsive">
              <table className="history-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Type</th>
                    <th>ID/Ticket</th>
                    <th>Doctor</th>
                    <th>Department</th>
                    <th>Complaint/Diagnosis</th>
                  </tr>
                </thead>
           <tbody>
  {data.map((item, index) => {
    // 1. Data Variables (Simple & Clean)
    // Backend se 'type' (small) aa raha hai, par hum safety ke liye dono check kar rahe hain
    const recordType = item.type || item.Type || "Unknown";
    
    // 2. Logic for Color (OPD = Blue, IPD = Pink)
    const isIPD = recordType === 'IPD';
    
    // 3. Inline Styles (Taaki CSS file ki galti ka chance na rahe)
    const badgeStyle = {
        backgroundColor: isIPD ? '#fce4ec' : '#e3f2fd', // Background
        color: isIPD ? '#880e4f' : '#0d47a1',           // Text Color
        border: `1px solid ${isIPD ? '#f8bbd0' : '#bbdefb'}`,
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '11px',
        fontWeight: '600',
        display: 'inline-block' // Ensure karega ki element gayab na ho
    };

    // Date formatting
    const dateVal = item.date || item.Date;
    const formattedDate = dateVal ? new Date(dateVal).toLocaleDateString("en-IN") : "-";

    return (
      <tr key={index}>
        {/* Date */}
        <td>{formattedDate}</td>
        
        {/* Type Badge (Ab ye ZAROOR dikhega) */}
        <td>
          <span style={badgeStyle}>
            {recordType}
          </span>
        </td>
        
        {/* Other Columns */}
        <td className="fw-bold">#{item.visitId || item.VisitId}</td>
        <td>{item.doctor || item.Doctor || "-"}</td>
        <td>{item.department || item.Department || "-"}</td>
        <td className="text-muted">{item.problem || item.Problem || "-"}</td>
      </tr>
    );
  })}
</tbody>
              </table>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>

      {/* Styles */}
      <style jsx>{`
        .modal-overlay {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0, 0, 0, 0.5); display: flex; justify-content: center; align-items: center; z-index: 10000;
          backdrop-filter: blur(2px);
        }
        .history-modal {
          background: white; width: 90%; max-width: 800px; border-radius: 12px; overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.2); animation: fadeIn 0.2s ease;
        }
        .modal-header {
          background: var(--theme-color, #0088cc); color: white; padding: 16px 20px;
          display: flex; justify-content: space-between; align-items: flex-start;
        }
        .modal-header h5 { margin: 0; font-size: 18px; font-weight: 600; }
        .subtitle { margin: 2px 0 0; font-size: 13px; opacity: 0.9; }
        .close-btn { background: none; border: none; color: white; font-size: 28px; line-height: 1; cursor: pointer; }
        
        .modal-body { padding: 0; max-height: 60vh; overflow-y: auto; }
        
        .history-table { width: 100%; border-collapse: collapse; font-size: 13px; }
        .history-table th { background: #f8f9fa; padding: 12px 15px; text-align: left; font-weight: 600; color: #495057; border-bottom: 2px solid #e9ecef; position: sticky; top: 0; }
        .history-table td { padding: 10px 15px; border-bottom: 1px solid #e9ecef; color: #212529; vertical-align: middle; }
        .history-table tr:hover { background-color: #f8f9fa; }

        .badge { padding: 4px 8px; border-radius: 4px; font-size: 11px; font-weight: 600; }
        .badge-opd { background: #e3f2fd; color: #0d47a1; border: 1px solid #bbdefb; }
        .badge-ipd { background: #fce4ec; color: #880e4f; border: 1px solid #f8bbd0; }

        .modal-footer { padding: 12px 20px; border-top: 1px solid #e9ecef; display: flex; justify-content: flex-end; background: #f8f9fa; }
        .btn-secondary { padding: 8px 20px; border-radius: 6px; border: 1px solid #ced4da; background: white; cursor: pointer; font-weight: 500; }
        .btn-secondary:hover { background: #e9ecef; }
        .empty-state { padding: 40px; text-align: center; color: #6c757d; }
        @keyframes fadeIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
      `}</style>
    </div>
  );
};

export default PatientHistoryModal;